<template>
  <Popper trigger="click" :options="options" :visible-arrow="false">
    <div class="mtx-dropdown px-1 py-1">
      <slot></slot>
    </div>

    <template slot="reference">
      <slot name="trigger">
        <button class="btn--link">
          Show
        </button>
      </slot>
    </template>
  </Popper>
</template>

<script>
// https://robinck.github.io/vue-popper/
// https://popper.js.org/popper-documentation.html
import Popper from "vue-popperjs"
import "vue-popperjs/dist/vue-popper.css"

export default {
  components: {
    Popper
  },

  props: {
    options: {
      type: Object
    }
  }
}
</script>

<style lang="scss">
.mtx-dropdown {
  border-radius: 0;
  color: $offBlack;
  background: $offWhite;
}
</style>
